module.exports = __webpack_public_path__ + "static/media/heroe256.051802ad.png";